import {computed, makeObservable, observable} from 'mobx'
import {LocalStorageGet, LocalStorageSet} from './Helpers'
import { LNG } from './LanguageService';

export enum MeasureTypes {
    Metric = 'Metric',
    Imperial = 'Imperial'
}

const MEASURE_KEY = 'measure'

export class MeasureService {
    public currentMeasure: MeasureTypes = MeasureTypes.Metric

    constructor() {
        makeObservable(this, {
            currentMeasure: observable,
            lengthUnits: computed,
            weightUnits: computed,
        })
    }

    public get lengthUnits() {
        return MeasureService.LengthUnitsByMeasure(this.currentMeasure)
    }

    public get weightUnits() {
        return MeasureService.WeightUnitsByMeasure(this.currentMeasure)
    }

    static LengthUnitsByMeasure(measure: MeasureTypes) {
        switch (measure) {
            case MeasureTypes.Imperial:
                return LNG.Text('Dashboard.51')
            case MeasureTypes.Metric:
                return LNG.Text('Dashboard.52')
            default:
                return LNG.Text('Dashboard.52')
        }
    }

    static WeightUnitsByMeasure(measure: MeasureTypes) {
        switch (measure) {
            case MeasureTypes.Imperial:
                return LNG.Text('Dashboard.49')
            case MeasureTypes.Metric:
                return LNG.Text('Dashboard.50')
            default:
                return LNG.Text('Dashboard.50')
        }
    }

    static ConvertLengthByMeasure(length: number, measure: MeasureTypes) {
        return Math.round(length / ((measure === MeasureTypes.Metric) ? 1000 : 1609))
    }

    static ConvertWeightByMeasure(weight: number, measure: MeasureTypes) {
        return Math.round(weight / ((measure === MeasureTypes.Metric) ? 1000 : 453))
    }

    public init() {
        const measure = LocalStorageGet<MeasureTypes>(MEASURE_KEY)
        if (measure) {
            this.currentMeasure = measure
        } else {
            this.setMeasure(MeasureTypes.Metric)
        }
    }

    public setMeasure(measure: string) {
        this.currentMeasure = measure as MeasureTypes
        LocalStorageSet(MEASURE_KEY, measure)
    }

    public convertLength(length: number) {
        return MeasureService.ConvertLengthByMeasure(length, this.currentMeasure)
    }

    public convertWeight(weight: number) {
        return MeasureService.ConvertWeightByMeasure(weight, this.currentMeasure)
    }

}